import React from "react";
import { ContactStyle } from "./style";
import { MapPin, WhatsappLogo, Clock } from "phosphor-react";
import { Link } from "react-router-dom";

export default function Contacts() {
  const title = 'Lavanderia Valentim'
  return (
    <ContactStyle id="contacts">
      <div className="block-container">
        <div className="contact">
          <h4>Contato</h4>

          <Link to="https://wa.me/5521964534762">
            <WhatsappLogo className="icon" />
            21 99202-1067 / 21 96453-4762
            <p>Clique no ícone do whatsapp para entrar em contato</p>
          </Link>

          <div className="location">
            <p>
              <MapPin className="icon" />
              Rua Araújo Leitão, 48 - b, Rio de janeiro - RJ, 20715-310
            </p>
          </div>

          <div className="hours">
            <p>
              <Clock className="icon" />
              08:00 ás 17:00
            </p>
          </div>
        </div>

        <div className="googlemaps">
          <iframe
            title={title.toString()}
            className="google-iframe"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3675.0160868584776!2d-43.268927985034125!3d-22.91277748500874!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x997dc189dd3cfd%3A0x8d0599200c0fb9d5!2sR.%20Ara%C3%BAjo%20Leit%C3%A3o%2C%2048%20-%20b%20-%20Engenho%20Novo%2C%20Rio%20de%20Janeiro%20-%20RJ%2C%2020715-310!5e0!3m2!1spt-BR!2sbr!4v1680807908897!5m2!1spt-BR!2sbr"
            allowFullScreen
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </ContactStyle>
  );
}
